import {AppThunk} from '../index';
import {httpService, HttpWrapperOptions} from '../../../shared/httpWrapper';
import {GetDobroRuOauthLinkResponsePayload} from '../../../shared/models/api';
import {dobroruActions} from '../../reducers/dobroru';
import {getApiRoute} from '../../../shared/pipes';
import {apiUrls} from '../../../shared/constants/urls';
import {addNotification} from '../snackbar';
import {SnackbarNotificationType} from '../../../shared/components/snackbar/model';
import {getHolderProfile} from '../profile';
import {DobroRuResponse} from '../../../shared/models/api/dobroruResponseData';
import {storage, StorageKeys} from '../../../shared/storage';
import {IndexItemValidationError} from '../../../shared/models/serverValidationError';
import {profileSlice} from '../../reducers/profile';

export const getDobroruLink = (): AppThunk => {
  return async (dispatch) => {
    try {
      const response = await httpService.get<GetDobroRuOauthLinkResponsePayload>(
        getApiRoute(apiUrls.dobroruLink),
        new HttpWrapperOptions().Wait(true).WaitTimeout(0),
      );

      dispatch(dobroruActions.setLink(response?.link ?? null));
    } catch (e) {
      dispatch(
        addNotification({
          message: 'Не удалось получить ссылку для авторизации на портале добро.ру',
          type: SnackbarNotificationType.Error,
        }),
      );
      dispatch(dobroruActions.setLink(null));
    }
  };
};

export const loginDobroru = (code: string): AppThunk => {
  return async (dispatch) => {
    try {
      await httpService.post(
        getApiRoute(apiUrls.dobroruLogin),
        {code},
        new HttpWrapperOptions().Wait(true).WaitTimeout(0),
      );

      await dispatch(getHolderProfile());
    } catch (e) {
      dispatch(
        addNotification({
          message: 'Не удалось авторизоваться через портал добро.ру',
          type: SnackbarNotificationType.Error,
        }),
      );
    }
  };
};

export const getDobroruData = (): AppThunk => {
  return async (dispatch, getState) => {
    const token: string | null = await storage.getItem(StorageKeys.token);
    if (getState().dobroru.dataLoading || !token) return;

    try {
      dispatch(dobroruActions.setDataLoading(true));

      const response = await fetch(getApiRoute(apiUrls.volunteerEvents), {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      if (!response.ok) {
        const error: IndexItemValidationError = await response.json();
        const errorText = error?.[0]?.message || 'Не удалось получить данные волонтера добро.ру';
        throw new Error(errorText);
      }
      const data: DobroRuResponse = await response.json();

      dispatch(dobroruActions.setData(data));
    } catch (e: any) {
      dispatch(
        addNotification({
          message: e?.message,
          type: SnackbarNotificationType.Error,
        }),
      );
      // dispatch(logoutDobroRu());
      dispatch(dobroruActions.setData(null));
    } finally {
      dispatch(dobroruActions.setDataLoading(false));
    }
  };
};

export const logoutDobroRu = (): AppThunk => {
  return async (dispatch) => {
    await httpService.post<void>(getApiRoute(apiUrls.signOutDobroRu));
    await dispatch(profileSlice.actions.signOutDobroRu(null));
  };
};
